import { useEffect, useState } from "react"
import AccountService from "../../api/AccountService";

export default function useTwoFactorIsEnabled({ email }) {
    const [isLoading, setIsLoading] = useState(false);
    const [isEnabled, setIsEnabled] = useState(null);

    useEffect(() => {
        fetchData();
    }, [])

    async function fetchData() {
        if(email == null) return;
        setIsLoading(true);
        try {
            const response = await AccountService.TwoFactorIsEnabled({ email });
            setIsEnabled(response.isEnabled);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }

    async function reload() {
        await fetchData();
    }

    return [isEnabled, isLoading, reload];
}